import type { intlFormatPropTypes } from "react-intl";
import { z } from "zod";

import {
  MAX_MINIMUM_DURATION_HOURS,
  MIN_MINIMUM_DURATION_HOURS,
} from "~/app/your-space/activate-listings/ActivateListingsPage.consts";

type BuildRulesFormSchemaArgs = {
  intl: intlFormatPropTypes;
};

const toNumberOrZero = (val: unknown) => {
  const num = Number(val);
  return Number.isNaN(num) ? 0 : num;
};

const buildListingRulesFormSchema = ({ intl }: BuildRulesFormSchemaArgs) =>
  z.object({
    rules: z.string().optional(),
    minAge: z.string(),
    minimumDuration: z.preprocess(
      toNumberOrZero,
      z
        .number()
        .min(
          MIN_MINIMUM_DURATION_HOURS,
          intl.formatMessage({
            id: "hosting.listing_rules.minimum_duration_required",
            defaultMessage: "Please enter a minimum duration",
          }),
        )
        .max(MAX_MINIMUM_DURATION_HOURS),
    ) as unknown as z.ZodType<number, z.ZodTypeDef, number>,
    numberOfGuests: z.preprocess(
      toNumberOrZero,
      z.number().min(
        1,
        intl.formatMessage({
          id: "hosting.listing_rules.capacity_required",
          defaultMessage: "Please enter a maximum number of guests",
        }),
      ),
    ) as unknown as z.ZodType<number, z.ZodTypeDef, number>,
  });

type ListingRulesFormValues = z.infer<
  ReturnType<typeof buildListingRulesFormSchema>
>;

export { buildListingRulesFormSchema };
export type { ListingRulesFormValues };
